@if (isTranslationLoaded()) {
  <h1 class="h2 mb-4">{{ 'selfOnboarding.verifyAccount.title' | translate }}</h1>
  <p>
    {{ 'selfOnboarding.verifyAccount.message' | translate }}
  </p>
}
